import * as types from './types';
import * as commonTypes from '../common/types';

export default (state = {}, action) => {
    switch (action.type) {
        case commonTypes.ASYNC_START: {
            return {
                ...state,
                loading: true,
                waitting: action.waitting,
                action: commonTypes.ASYNC_START,
            }
        }

        case commonTypes.ASYNC_END: {
            return {
                ...state,
                action: commonTypes.ASYNC_END,
                waitting: commonTypes.ASYNC_END,
                loading: false,
            }
        }
        case types.LIST_CREDIT_LOGS: {
            return {
                ...state,
                action: types.LIST_CREDIT_LOGS,
                creditlogs: action.status ? action.payload.creditlogs : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                userInfo: action.status ? action.payload.user : false,
                status: action.status,
                message: action.message,
            }
        }

        case types.CHANGE_CREDIT: {
            return {
                ...state,
                action: types.CHANGE_CREDIT,
                status: action.status,
                message: action.message,
            }
        }
        case types.CREATE_PARTNER: {
            return {
                ...state,
                action: types.CREATE_PARTNER,
                status: action.status,
                message: action.message,
            }
        }
        case types.REPORT_CREDIT_LOGS: {
            return {
                ...state,
                action: types.REPORT_CREDIT_LOGS,
                creditLogs: action.status ? action.payload.creditLogs : [],
                excelDatas: action.status ? action.payload.excelDatas : [],
                totalRecord: action.status ? action.payload.total : 0,
                totalPage: action.status ? action.payload.total_page : 0,
                status: action.status,
                message: action.message,
            }
        }

        case types.EXPORT_CREDIT_LOG: {
            return {
                ...state,
                action: types.EXPORT_CREDIT_LOG,
                url: action.status ? action.payload.url : '',
                status: action.status,
                message: action.message,
            }
        }
        default:
            return state;
    }
}

